const defaultOptions = {
  credentials: 'include',
  cache: 'no-cache',
  headers: {
    'Content-Type': 'application/json',
  },
};

export const simpleFetch = (uri, options = {}, baseUrl) =>
  fetch(`${baseUrl}${uri}`, { ...defaultOptions, ...options }).then((response) =>
    response.text().then((text) => {
      try {
        return JSON.parse(text);
      } catch {
        throw new Error('Something went wrong');
      }
    }),
  );

export const simpleFetchWithHttp = (uri, options = {}, baseUrl) =>
  fetch(`${baseUrl}${uri}`, { ...defaultOptions, ...options });
